<template>
    <section class="section__head head is_new-design status_hidden">
        <h1 class="head__title ptb__8 mr__32">
            <span class="head__main-title">{{title}}</span>
            <span class="head__sub-title"> /&nbsp;{{subTitle}}</span>
        </h1>
    </section>
</template>
<script>
export default {
    name: 'SectionPageHeader',
    props: {
        title: {
            type: String,
            default: () => ''
        },
        subTitle: {
            type: String,
            default: () => ''
        },
    },
}
</script>